declare namespace $ {

	export class $mol_icon_form_textbox extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=textbox.view.tree.d.ts.map